import { ModuleRatingDetails } from "./module-rating-details.screen";
import { PrivateRouteDefinition } from "../../../infecto-lms-admin/components/core/model/PrivateRouteDefinition";

export const MODULE_RATING_DETAILS_PATH = "/module-rating/:id";
export const getModuleRatingDetailsPath = (id: string) =>
	MODULE_RATING_DETAILS_PATH.replace(":id", id);
export const ModuleRatingDetailsRoutes: PrivateRouteDefinition[] = [
	{ element: <ModuleRatingDetails />, path: MODULE_RATING_DETAILS_PATH, requiredPermissions: [] },
];
